(function () {
  'use strict';

  /* Mobile menu */
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Collection sort */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Product page: gallery + variant picker */
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var dataEl = document.getElementById('VariantData');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add]');
  var priceEl = document.querySelector('[data-price]');
  var mainWrap = document.querySelector('[data-main-image]');
  var mainImg = mainWrap ? mainWrap.querySelector('img') : null;
  var groups = form.querySelectorAll('[data-option-group]');
  var stockEl = document.querySelector('[data-stock]');
  var sticky = document.querySelector('[data-sticky]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAdd = document.querySelector('[data-sticky-add]');

  function swapImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
  }

  var thumbs = document.querySelectorAll('[data-thumb]');
  Array.prototype.forEach.call(thumbs, function (btn) {
    btn.addEventListener('click', function () {
      swapImage(btn.getAttribute('data-src'));
      Array.prototype.forEach.call(thumbs, function (t) { t.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  function selectedOptions() {
    return Array.prototype.map.call(groups, function (g) {
      var checked = g.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function renderPrice(v) {
    var html = '<span class="price">';
    if (v.compare) {
      html += '<span class="price-now is-sale">' + v.price + '</span> <s class="price-was">' + v.compare + '</s>';
    } else {
      html += '<span class="price-now">' + v.price + '</span>';
    }
    html += '</span>';
    if (priceEl) priceEl.innerHTML = html;
    if (stickyPrice) stickyPrice.innerHTML = html;
  }

  function setButtons(disabled, label) {
    addBtn.disabled = disabled;
    addBtn.textContent = label;
    if (stickyAdd) { stickyAdd.disabled = disabled; stickyAdd.textContent = label; }
  }

  var shipEl = document.querySelector('[data-ship-est]');
  var SHIP_TIERS = [[500, 39], [1000, 99], [2000, 149], [3500, 209], [5000, 249], [8000, 349]];
  function renderShip(v) {
    if (!shipEl || !v) return;
    var grams = Number(v.weight) || 0;
    var sek = null;
    for (var i = 0; i < SHIP_TIERS.length; i++) { if (grams <= SHIP_TIERS[i][0]) { sek = SHIP_TIERS[i][1]; break; } }
    if (sek === null) { shipEl.hidden = true; return; }
    var cur = (window.Shopify && Shopify.currency) || {};
    var code = cur.active || 'SEK';
    var amount = sek * (Number(cur.rate) || 1);
    var txt;
    try { txt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code, maximumFractionDigits: code === 'SEK' ? 0 : 2 }).format(amount); }
    catch (e) { txt = Math.round(amount) + ' ' + code; }
    shipEl.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>' +
      '<span>Shipping for this item: <strong>' + txt + '</strong> · Sweden, EU &amp; USA</span>';
    shipEl.hidden = false;
  }
  (function () {
    var id = Number(idInput.value);
    for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { renderShip(variants[i]); break; } }
  })();

  function update() {
    var v = findVariant(selectedOptions());
    if (!v) {
      setButtons(true, 'Unavailable');
      if (stockEl) stockEl.hidden = true;
      return;
    }
    idInput.value = v.id;
    renderPrice(v);
    renderShip(v);
    setButtons(!v.available, v.available ? 'Add to cart' : 'Sold out');
    if (stockEl) {
      if (v.stock > 0) { stockEl.textContent = 'Only ' + v.stock + ' left in stock'; stockEl.hidden = false; }
      else { stockEl.hidden = true; }
    }
    if (v.image) swapImage(v.image);
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  Array.prototype.forEach.call(groups, function (g) {
    g.addEventListener('change', update);
  });

  /* Sticky add-to-cart bar: show once the main button scrolls out of view */
  if (sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting;
    });
    io.observe(addBtn);
  }
})();

/* ---------- Cart drawer + free shipping bar + country selector ---------- */
(function () {
  'use strict';
  var cfg = window.MAGDRIVE || {};
  var root = cfg.rootUrl || '/';
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.querySelector('.drawer-overlay');
  var itemsEl = document.querySelector('[data-drawer-items]');
  var footEl = document.querySelector('[data-drawer-foot]');
  var subtotalEl = document.querySelector('[data-drawer-subtotal]');
  var lastFocus = null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderShipBars(cart) {
    var bars = document.querySelectorAll('[data-ship-bar]');
    var base = Number(cfg.freeShippingThreshold) || 0;
    if (!bars.length) return;
    if (base <= 0 || !cart || cart.item_count === 0) {
      bars.forEach(function (b) { b.hidden = true; });
      return;
    }
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    var threshold = Math.round(base * rate * 100);
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
    var msg = remaining > 0
      ? 'Add <strong>' + money(remaining, cart.currency) + '</strong> more to get free shipping'
      : '<strong>You have free shipping!</strong>';
    var html = '<p>' + msg + '</p><div class="ship-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
    bars.forEach(function (b) { b.innerHTML = html; b.hidden = false; });
  }

  function renderDrawer(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    renderShipBars(cart);
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="drawer-empty"><p>Your cart is empty.</p><a class="btn" href="' + root + 'collections/all">Shop all products</a></div>';
      footEl.hidden = true;
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="muted">' + esc(item.variant_title) + '</p>' : '';
      return '<div class="drawer-item">' +
        (img ? '<a class="drawer-img" href="' + item.url + '"><img src="' + img + '" alt="' + esc(item.product_title) + '" loading="lazy" width="80" height="80"></a>' : '') +
        '<div class="drawer-info"><a class="drawer-title" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant +
        '<div class="drawer-qty"><button type="button" data-qty="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span aria-live="polite">' + item.quantity + '</span>' +
        '<button type="button" data-qty="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '<button type="button" class="drawer-remove" data-qty="' + (i + 1) + '" data-q="0">Remove</button></div></div>' +
        '<div class="drawer-price">' + money(item.final_line_price, cart.currency) + '</div></div>';
    }).join('');
    subtotalEl.textContent = money(cart.total_price, cart.currency);
    footEl.hidden = false;
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
    drawer.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('drawer-lock');
    if (lastFocus) lastFocus.focus();
  }

  // Initial state (cart page bar + counts)
  fetchCart().then(renderDrawer).catch(function () {});

  if (drawer) {
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        fetchCart().then(renderDrawer);
        openDrawer();
      });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      btn.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(btn.getAttribute('data-qty')), quantity: Math.max(0, Number(btn.getAttribute('data-q'))) })
      }).then(function (r) { return r.json(); }).then(renderDrawer).catch(function () { btn.disabled = false; });
    });

    // Add to cart without leaving the page
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btns = form.querySelectorAll('[type="submit"]');
      if (form.id) { try { btns = document.querySelectorAll('[type="submit"][form="' + form.id + '"], #' + form.id + ' [type="submit"]'); } catch (err) {} }
      btns.forEach(function (b) { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Adding…'; });
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderDrawer(cart); openDrawer(); })
        .catch(function () { form.submit(); })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; if (b.dataset.label) b.textContent = b.dataset.label; }); });
    });
  }

  // Country / currency selector submits on change
  var loc = document.querySelector('[data-locale-select]');
  if (loc) loc.addEventListener('change', function () { loc.form.submit(); });
})();
